import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
import { clsx } from 'clsx';

export default function ThemeToggle({ className }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      onClick={toggleTheme}
      aria-label={isDark ? 'Ativar tema claro' : 'Ativar tema escuro'}
      aria-pressed={isDark}
      className={clsx(
        'relative inline-flex items-center justify-center w-9 h-9 rounded-md',
        'text-text-muted hover:text-text-primary hover:bg-surface-raised',
        'transition-colors duration-normal',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-focus',
        className,
      )}
    >
      <Sun
        size={18}
        className={clsx(
          'absolute transition-all duration-slow',
          isDark ? 'opacity-0 rotate-90 scale-50' : 'opacity-100 rotate-0 scale-100',
        )}
        aria-hidden="true"
      />
      <Moon
        size={18}
        className={clsx(
          'absolute transition-all duration-slow',
          isDark ? 'opacity-100 rotate-0 scale-100' : 'opacity-0 -rotate-90 scale-50',
        )}
        aria-hidden="true"
      />
    </button>
  );
}
